<app-mrp-scrolltop></app-mrp-scrolltop>
<!-- Main -->
<main id="main" class="wrapper">
    <article class="inner">
        <div class="content">
            <h1 class="visually-hidden">Free Robert's Rules Meeting Tools and Guides</h1>
            <header><h2>Free Meeting Tools and Guides</h2></header>

            <ol>
                <li>A cheat sheet of RR motion precedence.</li>
                <li>A meeting guide for what to say, when.</li>
                <li>Member Rights and Responsibilities</li>
                <li>Duties of the Chair</li>                
            </ol>

            <div class="row">
                <div class="col-12-large">            

                    <!-- Table -->
                    <h3>MEETINGS</h3>
 
                    <div class="table-wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>View</th>
                                    <th>Download</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><a href="assets/pdf/RONRMotionPrecedence.pdf"><b>Motion Precedence</b></a></td>
                                    <td><a href="assets/pdf/RONRMotionPrecedence.pdf" download="RONRMotionPrecedence.pdf"><b>Link</b></a></td>
                               </tr>
                                <tr><td><a href="assets/pdf/RONRMeetingCheatsheet.pdf"><b>Meeting Guide</b></a></td>
                                    <td><a href="assets/pdf/RONRMeetingCheatsheet.pdf" download="RONRMeetingCheatsheet.pdf"><b>Link</b></a></td>
                                </tr>
                                          
                            </tbody>                            
                        </table>
                    </div>
                </div>              
            </div>

            <div class="row">
                <div class="col-12-large">  

                        <h3>Testimonials</h3>
                        <div class="box">
                            <blockquote>"Roberts Rules isn't for an individual, it's for the entire body."
                                <p> - Dave, State Committee
                                    <button class="interview-button" (click)="openVideoPlayer(1)" mat-icon-button aria-label="Open video player">
                                    <mat-icon class="interview-icon">videocam</mat-icon>
                                    </button>
                                </p>
                            </blockquote>
                        </div> 

                </div>
            </div>

            <div class="row">
                <div class="col-12-large">            

                    <!-- Table -->
                    <h3>MEMBER RIGHTS</h3>

                    <div class="table-wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>View</th>
                                    <th>Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><a href="assets/pdf/RONRMemberRightsAndResponsibilities.pdf"><b>All Rights and Responsibilities</b></a></td>
                                    <td><a href="assets/pdf/RONRMemberRightsAndResponsibilities.pdf" download="RONRMemberRightsAndResponsibilities.pdf"><b>Link</b></a></td>
                                </tr>
                                <tr><td><a href="assets/pdf/RONRMemberRights.pdf"><b>Member Rights</b></a></td>
                                    <td><a href="assets/pdf/RONRMemberRights.pdf" download="RONRMemberRights.pdf"><b>Link</b></a></td>
  
                                </tr>
                                <tr><td><a href="assets/pdf/RONRMemberResponsibilities.pdf"><b>Member Responsibilities</b></a></td>
                                    <td><a href="assets/pdf/RONRMemberResponsibilities.pdf" download="RONRMemberResponsibilities.pdf"><b>Link</b></a></td>
                                 </tr>
                                <tr><td><a href="assets/pdf/RONRProhibitedActions.pdf"><b>Prohibited Actions</b></a></td>
                                    <td><a href="assets/pdf/RONRProhibitedActions.pdf" download="RONRProhibitedActions.pdf"><b>Link</b></a></td>
                                </tr>
                                          
                            </tbody>                            
                        </table>
                    </div>
                </div>              
            </div>
           
            <div class="row">
                <div class="col-12-medium">            

                    <!-- Table -->
                    <h3>Duties of the Chair</h3>

                    <div class="table-wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>View</th>
                                    <th>Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><a href="assets/pdf/RONRDutiesOfChair.pdf"><b>Duties of the Chair</b></a></td>
                                    <td><a href="assets/pdf/RONRDutiesOfChair.pdf" download="RONRDutiesOfChair.pdf"><b>Link</b></a></td>
                                </tr>
                                <tr><td><a href="assets/pdf/CommitmentOfChair.pdf"><b>Commitment of the Chair</b></a></td>
                                    <td><a href="assets/pdf/CommitmentOfChair.pdf" download="CommitmentOfChair.pdf"><b>Link</b></a></td>  
                                </tr> 
                                <tr><td><a href="assets/pdf/LanguageForChair.pdf"><b>Language for the Chair</b></a></td>
                                    <td><a href="assets/pdf/LanguageForChair.pdf" download="LanguageForChair.pdf"><b>Link</b></a></td>  
                                </tr>                                
                                          
                            </tbody>                            
                        </table>
                    </div>
                </div>              
            </div>

           



        </div>      
           
    </article>
</main>


<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->

<!-- Testimonials Section -->
<section class="wrapper">
    <div class="inner">
        <div class="content">

            <!-- Elements -->
            <div class="row">
                <div class="col-12-medium">            

                    <div class="col-12-medium">    

                        <h3>Testimonials</h3>
                        <div class="box">
                            <blockquote>"This guide really helped. Had no idea how to read [the precident chart] before." - Jan</blockquote>
                            <blockquote>"Repeating the words really helped me understand them." - Mike</blockquote>
                        </div> 
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
